import { render, staticRenderFns } from "./ViewSwitcher.vue?vue&type=template&id=7ca7f527&scoped=true"
import script from "./ViewSwitcher.vue?vue&type=script&lang=js"
export * from "./ViewSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ViewSwitcher.vue?vue&type=style&index=0&id=7ca7f527&prod&scoped=true&lang=scss"
import style1 from "./ViewSwitcher.vue?vue&type=style&index=1&id=7ca7f527&prod&lang=css"
import style2 from "./ViewSwitcher.vue?vue&type=style&index=2&id=7ca7f527&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca7f527",
  null
  
)

export default component.exports